// extracted by mini-css-extract-plugin
export default {"wrapper":"customization_wrapper__UHcf+","content":"customization_content__tkKyZ","opacity-transition":"customization_opacity-transition__3pfXH"};